/* eslint-disable react-hooks/exhaustive-deps */
import { useRouter } from "next/router"
import { useEffect, useState } from "react"
import { Breadcrumb } from "@components/anti/Breadcrumb"
import Tabs from "@components/global/Tabs"
import { linkNewsroom } from "src/helper/page-url"
import { translations } from "src/helper/translations"
import NewsroomMediaKit from "./newsroom-media-kit"
import NewsroomPressRelease from "./newsroom-press-release"

function NewsroomLanding({ data, yearList, locale }) {
  const router = useRouter()
  const [dataTab, setDataTab] = useState([])
  const [activeTab, setActiveTab] = useState(null)
  const setData = (tab) => {
    const dataTabInitial = [
      {
        title:
          locale === "en"
            ? "Press Release & Events"
            : "Siaran Pers dan Kegiatan",
        key: "press-release-events",
        content: (
          <NewsroomPressRelease
            locale={locale}
            data={data}
            yearList={yearList}
          />
        ),
      },
      {
        title: locale === "en" ? "Media Kit" : "Perangkat Media",
        key: "media-kit",
        content: (
          <NewsroomMediaKit
            data={{ page: data?.mediaKit, gallery: data?.gallery }}
            locale={locale}
          />
        ),
      },
    ]
    setDataTab(dataTabInitial)
    if (!activeTab) setActiveTab(dataTabInitial[0])
    else {
      setActiveTab(
        dataTabInitial?.find((item) => item.key === (tab || activeTab.key))
      )
    }
  }
  useEffect(() => {
    setData()
  }, [locale])
  useEffect(() => {
    setData(router.query?.tab)
  }, [router.query])
  return (
    <section className="sc-newsroom-landing overflow-hidden">
      <div className="container">
        <Breadcrumb path={`/${translations[`newsroom_${locale}`]}`} />
      </div>
      <Tabs
        className="newsroom-tabs"
        navClassName="container"
        activeTabProps={activeTab}
        setActiveTabProps={(e) =>
          router.push({
            pathname: linkNewsroom,
            query: { ...router.query, tab: e.key },
          })
        }
        data={dataTab}
      />
    </section>
  )
}

export default NewsroomLanding
